import React from "react";
import "./side-drawer.scss";
import { navMenuItems } from "../../constants";
import PropTypes from "prop-types";

const handleHashNavigation = (url) => {
  window.location.replace(window.location.origin + "/" + url);
};

const sideDrawer = (props) => {
  let drawerClasses = ["side-drawer"];
  if (props.show) {
    drawerClasses = ["side-drawer", "open"];
  }
  return (
    <div className="side-drawer-container">
      <nav className={drawerClasses.join(" ")}>
        <ul onClick={props.click}>
          {navMenuItems.map(({ name, url }, index) => {
            return (
              <li key={index}>
                <a onClick={() => handleHashNavigation(url)} href={url}>
                  {name}
                </a>
              </li>
            );
          })}
        </ul>
        <div className="d-flex flex-row justify-content-center social-media-mobile-bar">
          <div>
            <a
              className="social-icon social-icon--github"
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/vipul-zambare006"
            >
              <i className="fa fa-github"></i>
            </a>
          </div>
          <div>
            <a
              className="social-icon social-icon--email"
              href="mailto:vipulzambare1993@gmail.com"
            >
              <i className="fa fa-envelope"></i>
            </a>
          </div>
          <div>
            <a
              className="social-icon social-icon--linkedin"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/vipul-zambare/"
            >
              <i className="fa fa-linkedin"></i>
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
};

sideDrawer.propTypes = {
  show: PropTypes.bool.isRequired,
  click: PropTypes.func.isRequired,
};

export default sideDrawer;
